<template>
  <AutocompleteFormField
    :optionsFetch="fetchAddress"
    :value="address"
    option-text="text"
    option-value="value"
    :return-object="false"
    label="Adresse"
    placeholder="Adresse eingeben"
    :rules="rules"
    :disabled="disabled"
    @input="handleAutocompleteInput"
  >
    <template v-slot:append>
      <v-btn
        v-if="adhAddress"
        class="suus__text-field-button"
        color="secondary"
        small
        @mousedown.stop="handleAdhClick"
        >ADH</v-btn
      >
    </template>
  </AutocompleteFormField>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref, watch } from "vue"
import AutocompleteFormField from "features/common/forms/form-fields/AutocompleteFormField.vue"

type AddressOption = {
  text: string
  value: string
}

type AddressFetch = (query: string) => Promise<string[]>

export default defineComponent({
  name: "AddressField",
  components: { AutocompleteFormField },
  props: {
    value: {
      type: String,
      required: false,
      default: "",
    },
    addressFetch: {
      type: Function as PropType<AddressFetch>,
      required: true,
    },
    adhAddress: {
      type: String,
      required: false,
      default: "",
    },
    rules: {
      type: Array as PropType<((v: any) => boolean | string)[]>,
      required: false,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, { emit }) {
    const _address = ref(props.value)
    watch(
      () => props.value,
      (value) => {
        _address.value = value
      }
    )
    const address = computed({
      get: () => _address.value,
      set: (value: string) => {
        _address.value = value
        emit("input", value)
      },
    })

    const handleAutocompleteInput = (value: string) => {
      address.value = value
    }

    const fetchAddress = async (query: string): Promise<AddressOption[]> => {
      const addresses = await props.addressFetch(query)
      console.log(
        "addresses",
        addresses.map((address) => ({
          text: address,
          value: address,
        }))
      )
      return addresses.map((address) => ({
        text: address,
        value: address,
      }))
    }

    const handleAdhClick = (e: Event) => {
      e.preventDefault()
      console.log("ADH clicked", props.adhAddress)
      address.value = props.adhAddress
    }

    return {
      address,
      fetchAddress,
      handleAdhClick,
      handleAutocompleteInput,
    }
  },
})
</script>
